import { render, staticRenderFns } from "./RegisterHospital.vue?vue&type=template&id=4af39eee&scoped=true&"
import script from "./RegisterHospital.vue?vue&type=script&lang=js&"
export * from "./RegisterHospital.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHospital.vue?vue&type=style&index=0&id=4af39eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af39eee",
  null
  
)

export default component.exports